import { render, staticRenderFns } from "./shouhu.vue?vue&type=template&id=36068018&scoped=true"
import script from "./shouhu.vue?vue&type=script&lang=js"
export * from "./shouhu.vue?vue&type=script&lang=js"
import style0 from "./shouhu.vue?vue&type=style&index=0&id=36068018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36068018",
  null
  
)

export default component.exports